import {Routes} from '@lit-labs/router';

/**
 * Copy of the Router class from lit-labs/router, because:
 * We need to handle errors (links to non-wishlist-pages)
 * when the route is not found by setting the location.href to the target page.
 * Simple overwriting the goto method is unfortunately not possible,
 * because in any case the history is pushed and then the target page would be duplicated in the history.
 */
export class WishlistRouter extends Routes {
  override hostConnected() {
    super.hostConnected();
    window.addEventListener('click', this._onClick);
    window.addEventListener('popstate', this._onPopState);
    // Kick off routed rendering by going to the current URL
    this.gotoWithHistory(window.location.pathname);
  }

  override hostDisconnected() {
    super.hostDisconnected();
    window.removeEventListener('click', this._onClick);
    window.removeEventListener('popstate', this._onPopState);
  }

  private _onClick = (e: MouseEvent) => {
    const isNonNavigationClick =
      e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey;
    if (e.defaultPrevented || isNonNavigationClick) {
      return;
    }

    const anchor = e
      .composedPath()
      .find(n => (n as HTMLElement).tagName === 'A') as
      | HTMLAnchorElement
      | undefined;
    if (
      anchor === undefined ||
      anchor.target !== '' ||
      anchor.hasAttribute('download') ||
      anchor.getAttribute('rel') === 'external'
    ) {
      return;
    }

    const href = anchor.href;
    if (href === '' || href.startsWith('mailto:')) {
      return;
    }

    const location = window.location;
    if (anchor.origin !== origin) {
      return;
    }

    e.preventDefault();
    if (href.startsWith(location.href) &&  href.endsWith('#main-content')) {
      const element = document.getElementById('main-content');
      if (element) {
        element.setAttribute('tabindex', '0');
        element.focus({ preventScroll: false });
        element.removeAttribute('tabindex');
        return;
      }
    }

    if (href !== location.href) {
      this.gotoWithHistory(anchor.pathname, anchor.href, true);
    }
  };

  private _onPopState = () => {
    this.gotoWithHistory(window.location.pathname);
  };

  public async gotoWithHistory(
    pathname: string,
    href: string = pathname,
    pushHistory: boolean = false,
  ) {
    try {
      await this.goto(pathname);
      if (pushHistory) {
        window.history.pushState({}, '', pathname);
      }
    } catch {
      document.location.href = href;
    }
  }
}
